import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordDollarSignIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 16.3804C12.1155 16.3804 13.8289 14.9522 13.8289 13.191C13.8289 11.4297 12.1155 9.99957 10 9.99957C7.88457 9.99957 6.17114 8.5714 6.17114 6.8082C6.17114 5.04691 7.88457 3.61873 10 3.61873M10 16.3804C7.88457 16.3804 6.17114 14.9522 6.17114 13.191M10 16.3804V17.6573M10 3.61873V2.3418M10 3.61873C12.1155 3.61873 13.8289 5.04691 13.8289 6.8082"
      />
    </svg>
  );
};

export default BordDollarSignIcon;
